import { render, staticRenderFns } from "./RollCall.vue?vue&type=template&id=744fff8f&"
import script from "./RollCall.vue?vue&type=script&lang=js&"
export * from "./RollCall.vue?vue&type=script&lang=js&"
import style0 from "./RollCall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports